import React from 'react'

export type BadgeTone = 'neutral' | 'signal' | 'active' | 'muted'

/**
 * Small tag, used for status labels like "Aktuel" / "Historisk" / role
 * names. Color is conveyed via a small set of semantic tones rather than
 * raw Tailwind classes so the visual language stays coherent.
 */
interface BadgeProps {
  tone?: BadgeTone
  children: React.ReactNode
  title?: string
  className?: string
}

const TONE_CLASSES: Record<BadgeTone, string> = {
  neutral: 'border-rule-strong bg-paper text-ink-700',
  signal: 'border-signal-200 bg-signal-50 text-signal-900',
  active: 'border-active-100 bg-active-50 text-active-900',
  muted: 'border-rule bg-paper-200 text-ink-500',
}

const Badge: React.FC<BadgeProps> = ({
  tone = 'neutral',
  children,
  title,
  className = '',
}) => {
  return (
    <span
      title={title}
      className={`inline-flex items-center gap-1 px-2 py-0.5 text-xs font-medium border rounded-sm ${TONE_CLASSES[tone]} ${className}`}
    >
      {children}
    </span>
  )
}

export default Badge
